import { TableModalActions } from 'constants/ActionsTypesTs'
import {
	IConfirmTableModalData,
	IConfirmTableModalDataResponse,
	IGetTableModalData,
	IGetTableModalDataResponse,
	IGetTableModalPagination,
	ISelectAllTableModalData,
	ISelectTableModalData
} from 'models/TableModal'

export const getTableModalData = (payload: IGetTableModalData) => ({
	type: TableModalActions.GET_TABLE_MODAL_DATA,
	payload
})

export const getTableModalDataSuccess = (
	response: IGetTableModalDataResponse
) => ({
	type: TableModalActions.GET_TABLE_MODAL_DATA_SUCCESS,
	response
})

export const getTableModalPagination = (payload: IGetTableModalPagination) => ({
	type: TableModalActions.GET_TABLE_MODAL_PAGINATION,
	payload
})

export const getTableModalPaginationSuccess = (
	response: IGetTableModalDataResponse
) => ({
	type: TableModalActions.GET_TABLE_MODAL_PAGINATION_SUCCESS,
	response
})

export const selectTableModalData = (payload: ISelectTableModalData) => ({
	type: TableModalActions.SELECT_TABLE_MODAL_DATA,
	payload
})

export const selectTableModalDataSuccess = (
	response: IGetTableModalDataResponse
) => ({
	type: TableModalActions.SELECT_TABLE_MODAL_DATA_SUCCESS,
	response
})

export const selectAllTableModalData = (payload: ISelectAllTableModalData) => ({
	type: TableModalActions.SELECT_ALL_TABLE_MODAL_DATA,
	payload
})

export const selectAllTableModalDataSuccess = (
	response: IGetTableModalDataResponse
) => ({
	type: TableModalActions.SELECT_ALL_TABLE_MODAL_DATA_SUCCESS,
	response
})

export const confirmTableModalData = (payload: IConfirmTableModalData) => ({
	type: TableModalActions.CONFIRM_TABLE_MODAL_DATA,
	payload
})

export const confirmTableModalDataSuccess = (
	response: IConfirmTableModalDataResponse
) => ({
	type: TableModalActions.CONFIRM_TABLE_MODAL_DATA_SUCCESS,
	response
})
